

import React, { useEffect, useState, useRef } from 'react';
import {IS_LOGIN,SET_TOKEN,setLogout} from '@/services';
import {LOGIN} from '@/services/wish'
import ShowLogin from '@/pages/components/dialog/alert/login';


const useLogin=(props)=>{
  const [isLogin,setLogin] = useState(IS_LOGIN());
  
  const login=async ()=>{
    if(IS_LOGIN()){
      setLogin(true);
      return true;
    }else{
      setLogin(false);
      const mobile = await ShowLogin();
      if(mobile){
        const loginReq = await LOGIN({mobile});
        if(loginReq?.code==0){
          SET_TOKEN(loginReq.data.api_token);
          setLogin(IS_LOGIN());
          return true;
        }
      }
    }
    return false;
  }
  useEffect(()=>{
    setLogout(login);
  })

  return {login,isLogin}
}

export default useLogin;
